export const ROLE_UPDATING = 'ROLE_UPDATING'
export const ROLE_UPDATE_SUCCESS = 'ROLE_UPDATE_SUCCESS'
export const ROLE_UPDATE_ERROR = 'ROLE_UPDATE_ERROR'

export const PAYMENT_METHODS_UPDATING = 'PAYMENT_METHODS_UPDATING'
export const PAYMENT_METHODS_UPDATE_SUCCESS = 'PAYMENT_METHODS_UPDATE_SUCCESS'
export const PAYMENT_METHODS_UPDATE_ERROR = 'PAYMENT_METHODS_UPDATE_ERROR'
